import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  param() {
    return faker.random.words(2);
  },

  val() {
    return faker.random.word();
  },

  afterCreate(externalReference, server) {
    externalReference.update({
      type: server.create('category', 'externalReferenceType'),
    });
  },
});
